import { ProductStateType } from './Product'

class Item {
  constructor(
    {
      id,
      itemId,
      name,
      stockCount,
      quantity,
      retailPrice,
      salePrice,
      supplyPrice,
      minCount = 1,
      maxCount = 1,
      imageUrl,
      checked = true,
      firstPurchaseOnlyProduct = false,
      state,
      unpurchasable,
      // disabled,
    }
  ) {
    this.id = id
    this.itemId = itemId
    this.name = name
    this.stockCount = stockCount
    this.quantity = quantity
    this.retailPrice = retailPrice
    this.salePrice = salePrice
    this.supplyPrice = supplyPrice
    this.minCount = minCount
    this.maxCount = maxCount || 100
    this.image = imageUrl || ''
    this.checked = stockCount < quantity ? false : checked
    this.locked = stockCount < quantity
    this.firstPurchaseOnlyProduct = firstPurchaseOnlyProduct
    this.state = ProductStateType[state]
    this.unpurchasable = unpurchasable
  }

  select(state) {
    if (this.stockCount < this.quantity) return
    this.checked = state
  }

  addQuantity() {
    if (this.quantity >= this.maxCount) return

    // if (this.quantity > this.stockCount) {
    //   this.checked = false
    //   return
    // }

    this.quantity += 1
  }

  subQuantity() {
    if (this.quantity <= this.minCount) return
    // console.log(this.quantity, this.disabled)

    // if (this.locked && this.quantity <= this.stockCount) {
    //   Vue.
    //   this.locked = false
    //   this.select(true)
    // }
    // if (this.quantity <= this.stockCount)

    this.quantity -= 1
  }

  setLocked(flag) {
    this.locked = flag
  }

  getId() {
    return this.id
  }

  getItemId() {
    return this.itemId
  }

  getName() {
    return this.name
  }

  getStockCount() {
    return this.stockCount
  }

  getQuantity() {
    return this.quantity
  }

  getLocked() {
    return this.locked
  }

  getRetailPrice() {
    return this.retailPrice
  }

  getSalePrice() {
    return this.salePrice
  }

  getSupplyPrice() {
    return this.supplyPrice
  }

  getMinCount() {
    return this.minCount
  }

  getMaxCount() {
    return this.maxCount
  }

  getImage() {
    return this.image
  }

  getChecked() {
    return this.checked
  }

  isPurchasable() {
    return this.state === ProductStateType.PURCHASABLE
  }

  isUnpurchasable() {
    return this.unpurchasable
  }

  getSoldOut() {
    return this.state === ProductStateType.SOLD_OUT
  }

  getDisabled() {
    return this.state === ProductStateType.DISABLED
  }

  getNotFirstPurchase() {
    return this.state === ProductStateType.NOT_FIRST_PURCHASE
  }

  getNotFirstPurchaseGuest() {
    return this.state === ProductStateType.NOT_FIRST_PURCHASE_GUEST
  }

  getFirstPurchaseOnlyProduct() {
    return this.firstPurchaseOnlyProduct
  }
}

export default Item
